import { useTranslation } from 'react-i18next';

import { KpiLateResponse } from 'types';
import { useThemedValueSwitch } from '@tq/ui-components';

export const useKpiTableRowTranslations = (
  lateResponses: KpiLateResponse[]
): KpiLateResponse[] => {
  const { isTQ } = useThemedValueSwitch();
  const { t } = useTranslation(isTQ ? 'tqen_annual_report' : 'annual_dfi_report');

  const resourceIssues = isTQ ? 'Lack of resources' : 'Resource issues';
  const extensionRequest = isTQ ? 'Extension request denied' : 'Extension request refused';
  const techIssuesInternal = isTQ
    ? 'Tech issues - internal to the organization'
    : 'Tech issues - internal to the organisation';
  const techIssuesExternal = isTQ
    ? 'Tech issues - external to the organization'
    : 'Tech issues - external to the organisation';
  const additionalInformationRequired = isTQ
    ? 'Additional information required'
    : 'Additional information required after consultation';

  const ROW_TEXT_LOOKUP: Record<string, string> = {
    [resourceIssues]: t(isTQ ? 'lack_of_resources' : 'resource_issues', resourceIssues),
    ['High volume of work']: t('high_volume_of_work', 'High volume of work'),
    [extensionRequest]: t(
      isTQ ? 'extension_request_denied' : 'extension_request_refused',
      extensionRequest
    ),
    [techIssuesInternal]: t(
      isTQ
        ? 'tech_issues_internal_to_the_organization'
        : 'tech_issues_internal_to_the_organisation',
      techIssuesInternal
    ),
    [techIssuesExternal]: t(
      isTQ
        ? 'tech_issues_external_to_the_organization'
        : 'tech_issues_external_to_the_organisation',
      techIssuesExternal
    ),
    ['Complexity of the case']: t('complexity_of_the_case', 'Complexity of the case'),
    [additionalInformationRequired]: t(
      isTQ
        ? 'additional_information_required'
        : 'additional_information_required_after_consultation',
      additionalInformationRequired
    ),
    ['Other']: t('other', 'Other'),
  };

  return lateResponses.map((row) => {
    return { ...row, lateResponseReason: ROW_TEXT_LOOKUP[row.lateResponseReason] };
  });
};
